// src/pages/Terms.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <div className="container mx-auto px-6 py-20 max-w-4xl">
        {/* Back button -> Signup */}
        <button
          onClick={() => navigate('/signup')}
          className="text-sm text-primary-600 hover:underline"
        >
          &larr; Back
        </button>

        <h1 className="text-3xl font-bold mt-6 mb-4">Terms of Service</h1>
        <p className="text-gray-700 dark:text-gray-300 mb-6">
          This is a placeholder Terms of Service. Replace this text with your full legal terms.
        </p>

        <section className="prose max-w-none dark:prose-invert">
          <h2>1. Acceptance of Terms</h2>
          <p>By using PaperMind AI you agree to these terms.</p>

          <h2>2. Use of Service</h2>
          <p>Explain acceptable use, prohibited uses, account requirements, etc.</p>

          <h2>3. Billing & Subscriptions</h2>
          <p>Describe billing model, renewals, cancellations, refunds.</p>

          <h2>4. Limitations & Disclaimers</h2>
          <p>Legal disclaimers and limitation of liability language go here.</p>

          <h2>Contact</h2>
          <p>
            If you have questions about these Terms, contact{' '}
            <a href="mailto:legal@yourdomain.com" className="text-primary-600 hover:underline">
              legal@yourdomain.com
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
